module.exports = __webpack_public_path__ + "static/assets/3d3b8fce985f973f14d3ebef6627a7f1.png";